<template>
  <div
    :id="`title-${dynamicNumber}`"
    class="section-title ProjectSectionTitle"
    :class="[`small-${content.small_bottom_margin}`,content.mobile_settings, `align-right-${content.align_right}` ]"
    :style="`color : ${customDescColor};background : ${customColor}; ${customGradient}; `"
  >
    <h3 :style="`width: ${customWidth}`">
      {{ content.section_title }}<span
        class="orange"
        :class="{hide: content.remove_dot}"
      >.</span> <br>
      <span v-if="content.section_subtitle">{{ content.section_subtitle }}<span
        v-if="content.include_dot"
        class="orange"
      >.</span> </span>
    </h3>
  </div>
</template>

<script>
/* Mixins */
import marked from "@/mixins/marked";

export default {
  mixins: [marked],
  props: {
    content: {
      type: Object,
      default: () => {}
    },
    isProject: {
      type: Boolean
    }
  },

  computed: {
    dynamicNumber() {
      const randomNum = Math.floor(1000 + Math.random() * 9000);
      return randomNum;
    },

    customColor() {
      if (this.content.bg_color) {
        return this.content.bg_color;
      } else {
        return "transparent";
      }
    },

    customGradient() {
      if (this.content.gradient_code) {
        return this.content.gradient_code;
      } else {
        return "";
      }
    },

    customDescColor() {
      if (this.content.color) {
        return this.content.color;
      } else {
        return "#000";
      }
    },

    customWidth() {
      if (this.$store.state.isMobile) {
        return "100%";
      } else {
        return this.content.width + "%";
      }
    },
  },
};
</script>

<style lang="scss">
.ProjectSectionTitle {
  max-width: 100vw;
  padding-top: 13vw;
  padding-bottom: 5vw;
  overflow-x: hidden;
  overflow-y: hidden;
  width: 100%;


  &.align-right-true {
    @include tablet {
      text-align: right;
    }
  }

  .hide {
    display: none;
  }

  strong {
    color: $orange;
  }

  h3 {
      font-size: 32px;
    line-height: 1.1;

      @include tablet {
    font-size: 48px;

  }

      @include desktop-sm {
    font-size: 54px;
  }

  @include desktop-l {
    font-size: 64px;
  }

  @include desktop-xl {
    font-size: 74px;
  }
  }

  @include tablet {
    padding-top: 7.7vw;
    padding-bottom: 1.5vw;
    @include paddingBig;
  }

  &.small-true {
    padding-bottom: 2vw;

    @include tablet {
      padding-bottom: 0.3vw;
    }
  }

  &.hide-mobile {
  display: none;

  @include tablet {
    display: block;
  }

}



}
</style>
